/**
 * Normalise human-readable text for search/grouping without changing IDs or codes.
 *
 * This intentionally handles only display text: case, Unicode presentation variants, and
 * accidental whitespace. Callers that compare IDs/ticket codes should keep exact matching.
 */
export function normalizeHumanText(value: string): string {
  return value
    .normalize('NFKC')
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('en-US')
}

/** Keep the user's spelling, but remove presentation-only whitespace/Unicode differences. */
export function cleanHumanLabel(value: string): string {
  return value.normalize('NFKC').trim().replace(/\s+/g, ' ')
}

export function humanTextIncludes(haystack: string, needle: string): boolean {
  return normalizeHumanText(haystack).includes(normalizeHumanText(needle))
}
